import Home from '@/components/Home'
import Login from '@/components/Auth/Login'
import Index from '@/components/Index/Index'
import Order from '@/components/Order/Index'
import OrderAddTalk from '@/components/Order/AddTalk'
import OrderAddChindle from '@/components/Order/AddChindle'
import OrderEditChindle from '@/components/Order/EditChindle'
import OrderTalkDetail from '@/components/Order/TalkDetail'
import OrderProblem from '@/components/Order/OrderProblem'
import Role from '@/components/Power/Role/Index'
import RoleAdd from '@/components/Power/Role/Add'
import Account from '@/components/Power/Account/Index'
import AccountAdd from '@/components/Power/Account/Add'
import Password from '@/components/Password/Index'
import Fast from '@/components/Fast/Index'
import FastType from '@/components/Fast/FastType'
import Statistics from '@/components/Statistics/Index'
import Service from '@/components/Statistics/Service'
import StatisticsWork from '@/components/Statistics/Work'
import WorkDetail from '@/components/Statistics/WorkDetail'
import SatisfactionDetails from '@/components/Statistics/Satisfaction'
import RobotSort from '@/components/RobotSort/Index'
import TalkRobot from '@/components/Robot/TalkRobot'
import AppraiseSet from '@/components/AppraiseManage/AppraiseSet.vue'
import ServiceStatistics from '@/components/AppraiseManage/ServiceStatistics.vue'
// import NoteInfo from '@/components/Order/NoteInfo'
import Message from '@/components/Message/Index'
import MessageSet from '@/components/Message/Set'
import MessageDetail from '@/components/Message/Detail'
import DefaultSet from '@/components/Default/Set'
import TalkRobotEdit from '@/components/Robot/TalkRobotEdit'
import Problem from '@/components/Statistics/Problem'
import ProblemEvaluation from '@/components/Statistics/ProblemEvaluation'
import ProblemKeyword from '@/components/Statistics/ProblemKeyword'
import Consult from '@/components/Statistics/Consult'
import SystemParams from '@/components/System/Params'
import VisitLog from '@/components/Statistics/VisitLog'
let routers = [{
  path: '*'
}, {
  path: '/',
  redirect: '/index',
  component: Home
}, {
  path: '/login',
  component: Login,
  name: 'Login'
}, { // 首页
  path: '/index',
  component: Home,
  children: [{ // 首页
    path: '/index',
    component: Index,
    name: 'Index',
    meta: {
      parent: 'Index',
      title: '首页'
    }
  }, { // 工单
    path: '/order',
    component: Order,
    name: 'Order',
    meta: {
      parent: 'Order',
      title: '客服工单'
    }
  }, { // 新增工单
    path: '/order/talk/add',
    component: OrderAddTalk,
    name: 'OrderAddTalk',
    meta: {
      parent: 'Order',
      title: '新增客服工单'
    }
  }, { // 工单编辑
    path: '/order/talk/edit',
    component: OrderAddTalk,
    name: 'OrderEditTalk',
    meta: {
      parent: 'Order',
      title: '编辑客服工单'
    }
  }, { // 新增青豆用户信息
    path: '/order/chindle/add',
    component: OrderAddChindle,
    name: 'OrderAddChindle',
    meta: {
      parent: 'Chindle',
      title: '新增青豆用户信息'
    }
  }, { // 编辑青豆用户信息
    path: '/order/chindle/edit/:id',
    component: OrderEditChindle,
    name: 'OrderEditChindle',
    meta: {
      parent: 'Chindle',
      title: '编辑青豆用户信息'
    }
  }, { // 工单详情
    path: '/order/talk/detail/:id',
    component: OrderTalkDetail,
    name: 'OrderTalkDetail',
    meta: {
      parent: 'Order',
      title: '客服工单详情'
    }
  }, { // 工单问题分类管理
    path: '/order/problem',
    component: OrderProblem,
    name: 'OrderProblem',
    meta: {
      parent: 'OrderProblem',
      title: '工单问题分类管理'
    }
  }, { // 角色管理
    path: '/role',
    component: Role,
    name: 'Role',
    meta: {
      parent: 'Role',
      title: '角色管理'
    }
  }, { // 新增角色
    path: '/role/add',
    component: RoleAdd,
    name: 'RoleAdd',
    meta: {
      parent: 'Role',
      title: '新增角色'
    }
  }, { // 编辑角色
    path: '/role/edit',
    component: RoleAdd,
    name: 'RoleEdit',
    meta: {
      parent: 'Role',
      title: '编辑角色'
    }
  }, { // 账号管理
    path: '/account',
    component: Account,
    name: 'Account',
    meta: {
      parent: 'Account',
      title: '账号管理'
    }
  }, { // 账号管理 - 新增
    path: '/account/add',
    component: AccountAdd,
    name: 'AccountAdd',
    meta: {
      parent: 'Account',
      title: '新增账号'
    }
  }, { // 账号管理 - 新增
    path: '/account/edit',
    component: AccountAdd,
    name: 'AccountEdit',
    meta: {
      parent: 'Account',
      title: '编辑账号'
    }
  }, { // 账号管理 - 编辑查看权限
    path: '/edit/see/role/:userId',
    component: resolve => require(['@/components/Power/Account/EditSeeRole'], resolve),
    name: 'EditSeeRole',
    meta: {
      parent: 'Account',
      title: '编辑查看权限'
    }
  }, { // 修改密码
    path: '/password',
    component: Password,
    name: 'Password',
    meta: {
      parent: 'Password',
      title: '修改密码'
    }
  }, { // 快捷语
    path: '/fast',
    component: Fast,
    name: 'Fast',
    meta: {
      parent: 'Fast',
      title: '快捷语管理'
    }
  }, { // 快捷语分类管理
    path: '/fast/type',
    component: FastType,
    name: 'FastType',
    meta: {
      parent: 'FastType',
      title: '快捷语分类管理'
    }
  }, { // 统计概览
    path: '/statistics',
    component: Statistics,
    name: 'Statistics',
    meta: {
      parent: 'Statistics',
      title: '统计总览'
    }
  }, { // 客服统计
    path: '/statistics/service',
    component: Service,
    name: 'Service',
    meta: {
      parent: 'Service',
      title: '客服统计'
    }
  }, { // 工作质量
    path: '/statistics/work',
    component: StatisticsWork,
    name: 'StatisticsWork',
    meta: {
      parent: 'StatisticsWork'
    }
  }, { // 工作质量
    path: '/work/detail/:id',
    component: WorkDetail,
    name: 'WorkDetail',
    meta: {
      parent: 'Service',
      title: '评价详情'
    }
  }, { // 满意度详情
    path: '/satisfaction',
    component: SatisfactionDetails,
    name: 'SatisfactionDetails',
    meta: {
      parent: 'SatisfactionDetails',
      title: '满意度详情'
    }
  }, {
    // 机器人分类设置
    path: '/robot/sort',
    component: RobotSort,
    name: 'RobotSort',
    meta: {
      parent: 'RobotSort',
      title: '机器人分类设置'
    }
  }, {
    // 机器人管理 > 新增
    path: '/robot/talkRobot/add',
    component: TalkRobotEdit,
    name: 'TalkRobotAdd',
    meta: {
      parent: 'TalkRobot',
      title: '新增机器人'
    }
  }, {
    // 机器人管理 > 编辑
    path: '/robot/talkRobot/edit/:id',
    component: TalkRobotEdit,
    name: 'TalkRobotEdit',
    meta: {
      parent: 'TalkRobot',
      title: '编辑机器人'
    }
  }, {
    // 机器人管理
    path: '/robot/talkRobot',
    component: TalkRobot,
    name: 'TalkRobot',
    meta: {
      parent: 'TalkRobot',
      title: '机器人管理'
    }
  }, {
    path: '/appraise/set',
    component: AppraiseSet,
    name: 'AppraiseSet',
    meta: {
      parent: 'AppraiseSet',
      title: '评价设置'
    }
  }, {
    path: '/service/statistics',
    component: ServiceStatistics,
    name: 'ServiceStatistics',
    meta: {
      parent: 'ServiceStatistics',
      title: '评价统计'
    }
  }, {
    path: '/service/aiKeyword',
    component: resolve => require(['@/components/Statistics/AiKeyword'], resolve),
    name: 'AiKeyword',
    meta: {
      parent: 'AiKeyword',
      title: 'AI关键字统计'
    }
  }, {
    path: '/service/aiKeywordReply',
    component: resolve => require(['@/components/Statistics/AiKeywordReply'], resolve),
    name: 'AiKeywordReply',
    meta: {
      parent: 'AiKeyword',
      title: '关键字回复列表'
    }
  }, { // 留言管理 - 留言设置
    path: '/message/set',
    component: MessageSet,
    name: 'MessageSet',
    meta: {
      parent: 'MessageSet',
      title: '留言设置'
    }
  }, { // 留言管理 - 留言管理
    path: '/message/index',
    component: Message,
    name: 'Message',
    meta: {
      parent: 'Message',
      title: '留言管理'
    }
  }, { // 留言管理 - 留言详情
    path: '/message/detail/:id',
    component: MessageDetail,
    name: 'MessageDetail',
    meta: {
      parent: 'Message',
      title: '留言详情'
    }
  }, { // 默认语设置 - 默认语设置
    path: '/default/set',
    component: DefaultSet,
    name: 'DefaultSet',
    meta: {
      parent: 'DefaultSet',
      title: '默认语设置'
    }
  }, { // 统计 - 机器人问答统计
    path: '/problem',
    component: Problem,
    name: 'Problem',
    meta: {
      parent: 'Problem',
      title: '机器人问答统计'
    }
  }, { // 机器人问答统计 - 问答评价详情
    path: '/problem/evaluation',
    component: ProblemEvaluation,
    name: 'ProblemEvaluation',
    meta: {
      parent: 'Problem',
      title: '问答评价详情'
    }
  }, { // 机器人问答统计 - 关键字搜索详情
    path: '/problem/keyword',
    component: ProblemKeyword,
    name: 'ProblemKeyword',
    meta: {
      parent: 'Problem',
      title: '关键字搜索详情'
    }
  }, { // 统计 - 分时咨询统计
    path: '/statistics/consult',
    component: Consult,
    name: 'Consult',
    meta: {
      parent: 'Consult',
      title: '分时咨询统计'
    }
  },
  { // 默认语设置 - 系统参数设置
    path: '/system/params',
    component: SystemParams,
    name: 'SystemParams',
    meta: {
      parent: 'SystemParams',
      title: '系统参数设置'
    }
  },
  { // 默认语设置 - 数据字典
    path: '/data/dictionary',
    component: resolve => require(['@/components/System/DataDictionary'], resolve),
    name: 'DataDictionary',
    meta: {
      parent: 'DataDictionary',
      title: '数据字典'
    }
  },
  {
    // 默认语设置 - 用户类型语言设置
    path: '/user/language',
    component: resolve => require(['@/components/System/UserTypeLanguageSet'], resolve),
    name: 'UserTypeLanguageSet',
    meta: {
      parent: 'UserTypeLanguageSet',
      title: '用户类型语言设置'
    }
  },
  {
    // 平台管理 - 平台管理
    path: '/platform',
    component: resolve => require(['@/components/Platform/Index'], resolve),
    name: 'CustomerPlatform',
    meta: {
      parent: 'CustomerPlatform',
      title: '平台管理'
    }
  },
  {
    // 平台管理 - 新增二级平台
    path: '/platform/add',
    component: resolve => require(['@/components/Platform/Add'], resolve),
    name: 'PlatformAdd',
    meta: {
      parent: 'CustomerPlatform',
      title: '新增二级平台'
    }
  },
  {
    // 平台管理 - 编辑二级平台
    path: '/platform/edit',
    component: resolve => require(['@/components/Platform/Add'], resolve),
    name: 'PlatformEdit',
    meta: {
      parent: 'CustomerPlatform',
      title: '编辑二级平台'
    }
  },
  {
    // 点对点管理 - 聊天记录
    path: '/chat/history',
    component: resolve => require(['@/components/P2P/ChatHistory'], resolve),
    name: 'ChatHistory',
    meta: {
      parent: 'ChatHistory',
      title: '聊天记录'
    }
  },
  { // 登录日志
    path: '/statistics/visitlog',
    component: VisitLog,
    name: 'VisitLog',
    meta: {
      parent: 'VisitLog',
      title: '登录日志'
    }
  }
  ]
}]
export default routers



// WEBPACK FOOTER //
// ./src/router/general.js